export default __webpack_public_path__ + "static/media/albufeira66Logo.5fcaf077.png";